var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "2 2 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.098 8.952l2.475 2.475a.75.75 0 01-1.06 1.06l-2.475-2.474-2.475 2.474a.75.75 0 01-1.06-1.06l2.474-2.475-2.475-2.475a.75.75 0 111.06-1.06L9.039 7.89l2.475-2.475a.75.75 0 011.06 1.061l-2.475 2.475zM9 18A9 9 0 109 0a9 9 0 000 18z",
    id: "add_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#add_svg__a",
    transform: "rotate(45 7.586 12.414)",
    fillRule: "evenodd"
  })));
}
export default SvgAdd;